if (!customElements.get('product-description-toggle')) {
  class ProductDescriptionToggle extends HTMLElement {
    connectedCallback() {
      this.description = this.querySelector('.product-description');
      this.button = this.querySelector('.product-description__toggle');
      
      if (!this.description || !this.button) return;
      
      this.isExpanded = false;
      this.button.addEventListener('click', this.toggle.bind(this));
      
      // Wait for fonts and layout to settle
      if (document.readyState === 'complete') {
        this.checkTruncation();
      } else {
        window.addEventListener('load', () => this.checkTruncation());
      }
    }

    checkTruncation() {
      const lineHeight = parseFloat(window.getComputedStyle(this.description).lineHeight);
      const maxHeight = lineHeight * 3.5; // Slightly more tolerance
      
      if (this.description.scrollHeight <= maxHeight) {
        this.button.style.display = 'none';
      }
    }

    toggle() {
      this.isExpanded = !this.isExpanded;
      
      if (this.isExpanded) {
        this.description.classList.remove('product-description--truncated');
        this.button.textContent = this.button.dataset.lessText;
      } else {
        this.description.classList.add('product-description--truncated');
        this.button.textContent = this.button.dataset.moreText;
        this.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      }
    }
  }

  customElements.define('product-description-toggle', ProductDescriptionToggle);
}